import request from '@/utils/request';

export function listTransToolInfo(data) {
  return request({
    url: '/transTool/listTransToolInfo',
    method: 'post',
    data,
  });
}
export function updateTransToolInfo(data) {
  return request({
    url: '/transTool/updateTransToolInfo',
    method: 'post',
    data,
  });
}
export function getQrcodePage(params) {
  return request({
    url: '/transTool/getQrcodePage',
    method: 'get',
    params,
  });
}
